import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    Box,
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { format } from 'date-fns';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import InfluencerService from '../../../Services/InfluencerService';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));

function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}

interface NewsDataProps {
    news: InfluencerModel | null;
    setNews: (news: InfluencerModel) => void;
    newsCurrentId: number | null;
    setNewsCurrentId: (currentId: number | null) => void;
    erros: ErrosFormulario;
    showErrors: boolean;
}
export function validateInfluencerReviser(news: InfluencerModel) {
    const errors: any = {};
    if (!news.territorioId) errors.territorioId = true;
    if (!news.tamanhoId) errors.tamanhoId = true;
    if (!news.nivelRiscoId) errors.nivelRiscoId = true;

    return errors;
}

type ErrosFormulario = Partial<Record<keyof InfluencerModel, string>>;
export default function InfluencerDataReputacao({ news, setNews, newsCurrentId, setNewsCurrentId, erros, showErrors }: NewsDataProps) {
    const classes = useStyles();

    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [loading, setLoading] = React.useState(false);

    const [nomeDisabled, setNomeDisabled] = React.useState(true);
    const [nomeFocused, setNomeFocused] = React.useState(false);

    const [urlPerfilDisabled, setUrlPerfilDisabled] = React.useState(true);
    const [urlPerfilFocused, setUrlPerfilFocused] = React.useState(false);

    const [iniciativaDisabled, setIniciativaDisabled] = React.useState(true);
    const [iniciativaFocused, setIniciativaFocused] = React.useState(false);

    const [objetivoContratacaoDisabled, setObjetivoContratacaoDisabled] = React.useState(true);
    const [objetivoContratacaoFocused, setObjetivoContratacaoFocused] = React.useState(false);



    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    setFiltersData(res.data);

                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }

    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof ClassificationInfluencerModel) => (event: React.ChangeEvent<HTMLInputElement> | any) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };

    const handleChangeDate = (prop: keyof ClassificationInfluencerModel) =>
        (date: Date | null) => {
            if (date) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                setNews(prevNews => ({
                    ...prevNews,
                    [prop]: toBrasiliaISOString(date),
                }));
            }
        };

    const handleChangeSelect = (prop: keyof ClassificationInfluencerModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event.target.value as string });
        };



    const getValidadeAnalise = () => {
        return (
            <>
                <Grid item xs={4}>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <DatePicker
                            id="news-date"
                            variant="inline"
                            defaultValue={news?.validadeAnalise}
                            inputVariant="outlined"
                            label="Validade da análise"
                            minDate={new Date().toISOString()}
                            onChange={handleChangeDate('validadeAnalise')}
                            format="dd/MM/yyyy"
                            className={classes.itemData}
                            value={news?.validadeAnalise ? news?.validadeAnalise : new Date().toISOString()} />
                    </MuiPickersUtilsProvider>
                </Grid>
            </>
        );

    };

    const getAnaliseReputacional = () => {
        return (
            <>
                <Grid item xs={8}>
                    <TextField
                        id="AnaliseReputacional"
                        value={news?.analiseReputacional}
                        onChange={handleChange('analiseReputacional')}
                        label="Análise Reputacional"
                        variant="outlined"
                        className={classes.itens}
                        multiline
                        minRows={6}
                        maxRows={6}
                        style={{ marginBottom: 100 }}
                    />
                </Grid>
            </>
        );
    };

    const getEvidencias = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="evidencias"
                        value={news?.evidencias}
                        onChange={handleChange('evidencias')}
                        label="Evidências"
                        variant="outlined"
                        className={classes.itens} />
                </Grid>
            </>
        );
    };


    const selectTerritorio = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.territorioId && !news?.territorioId}
                >
                    <Autocomplete
                        id="territorio-autocomplete"
                        options={filters?.territorio ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.territorio?.find(t => t.id_aux === news?.territorioId) || null}
                        // onChange={(_, newValue) => {
                        //     setNews({
                        //         ...news,
                        //         territorioId: newValue ? newValue.id_aux : 0
                        //     });
                        // }}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                territorioId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Território"
                                variant="outlined"
                                error={!!erros.territorioId && !news?.territorioId}
                                required
                            />
                        )}
                    />
                    {(erros.territorioId && !news?.territorioId) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectTamanho = () => {
        return (
            <>
                <Grid item xs={4}>
                    <FormControl
                        variant="outlined"
                        style={{ width: '100%' }}
                        required error={!!erros.tamanhoId && !news?.tamanhoId}
                    >
                        <InputLabel id="submit-select" style={{ color: 'black' }}>Tamanho</InputLabel>
                        <Select
                            labelId="submit-select"
                            id="submit-select"
                            value={news?.tamanhoId ?? ''}
                            label="tamanho"
                            onChange={handleChangeSelect('tamanhoId')}
                            style={{
                                outline: 'none',
                                borderBottom: 'none',
                            }}
                        >
                            <MenuItem value={undefined}>Selecione</MenuItem>
                            {filters?.tamanho?.map((item) => (
                                <MenuItem key={item.id} value={item.id_aux}>{item.descricao}</MenuItem>
                            ))}
                        </Select>
                        {(erros.tamanhoId && !news?.tamanhoId) && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </>
        );
    };
    const selectNivelRisco = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required error={!!erros.nivelRiscoId && !news?.nivelRiscoId}
                >
                    <Autocomplete
                        id="nivelRisco-autocomplete"
                        options={filters?.nivel_risco ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.nivel_risco?.find(n => n.id_aux === news?.nivelRiscoId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                nivelRiscoId: newValue && typeof newValue.id_aux === 'number' ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Nível de Risco"
                                variant="outlined"
                                error={!!erros.nivelRiscoId && !news?.nivelRiscoId}
                                required
                            />
                        )}
                    />
                    {(erros.nivelRiscoId && !news?.nivelRiscoId) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };




    return (
        <>
            <Grid>
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start" >
                    {selectTerritorio()}
                    {selectTamanho()}
                    {getEvidencias()}
                    {getValidadeAnalise()}
                    {selectNivelRisco()}
                    {getAnaliseReputacional()}
                </Grid>
            </Grid>
        </>
    );
}